import { useUrlParamsValueToString } from "@harea/component"
import { useCallback } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"

export const useProjectTimeOffNavigateBack = () => {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()

    return useCallback(() => {
        const newParams = new URLSearchParams(searchParams);
        if (newParams.get("bulk")) {
            newParams.delete("bulk");
        }
        navigate(`..?${newParams.toString()}`);

    }, [searchParams])
}
